import { createBrowserClient } from '@gatheredhq/database';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY environment variables');
}

// Use localStorage (not sessionStorage) so PKCE code_verifier survives email verification
// opening in a new tab. Tab-isolated sessions were causing email callback failures.
export const supabase = createBrowserClient(supabaseUrl, supabaseAnonKey, 'sb-ghq-dashboard-auth', window.localStorage);
